'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var classnames = require('classnames');
var React = require('react');
var styled = require('styled-components');
require('../../../../enums/accordion.js');
require('../../../../enums/alert.js');
require('../../../../enums/avatar.js');
require('../../../../enums/breakpoints.js');
require('../../../../enums/button.js');
require('../../../../enums/code-editor.js');
require('../../../../enums/colors.js');
require('../../../../enums/combobox.js');
require('../../../../enums/date.js');
require('../../../../enums/drag-and-drop.js');
require('../../../../enums/dialog.js');
require('../../../../enums/divider.js');
require('../../../../enums/dropdown.js');
require('../../../../enums/fieldset.js');
require('../../../../enums/font-icon.js');
require('../../../../enums/fonts.js');
require('../../../../enums/headings.js');
require('../../../../enums/input.js');
require('../../../../enums/keys.js');
require('../../../../enums/list.js');
require('../../../../enums/listbox.js');
require('../../../../enums/loader.js');
require('../../../../enums/margin.js');
require('../../../../enums/option.js');
require('../../../../enums/pill.js');
require('../../../../enums/placements.js');
require('../../../../enums/popout.js');
require('../../../../enums/privacy.js');
require('../../../../enums/radio-group.js');
require('../../../../enums/status.js');
require('../../../../enums/switch.js');
var table = require('../../../../enums/table.js');
require('../../../../enums/tooltip.js');
require('../../../../enums/transitions.js');
require('../../../../enums/widths.js');
require('../../../../themes/alert.js');
require('../../../../themes/button.js');
require('../../../../themes/checkbox.js');
require('../../../../themes/divider.js');
require('../../../../themes/dropdown.js');
require('../../../../themes/fieldset.js');
var fonts = require('../../../../themes/fonts.js');
require('../../../../themes/input.js');
require('../../../../themes/list.js');
require('../../../../themes/listbox.js');
require('../../../../themes/loader.js');
require('../../../../themes/option.js');
require('../../../../themes/popout.js');
require('../../../../themes/switch.js');
var themes = require('../../../../themes/themes.js');
require('../../../../themes/tooltip.js');
var baseTable = require('../base-table/base-table.js');
var tableWrapper = require('./table-wrapper.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var classnames__default = /*#__PURE__*/_interopDefaultCompat(classnames);
var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const UnstyledTable = (props)=>{
    const { breakpoints , children , className , empty , error , footer , hover , id , loading , look , ...otherProps } = props;
    return /*#__PURE__*/ React__default.default.createElement(baseTable.BaseTable, _extends({}, otherProps, {
        className: classnames__default.default({
            'bf-table__standard-table': true,
            'bf-table__standard-table--breakpoints': !!breakpoints,
            'bf-table__standard-table--empty': empty,
            'bf-table__standard-table--error': error,
            'bf-table__standard-table--footer': footer,
            'bf-table__standard-table--hover': hover,
            'bf-table__standard-table--loading': loading,
            [`bf-table__standard-table--${look}`]: look,
            [`${className}`]: !!className
        }),
        id: id
    }), children);
};
const blockTable = styled.css`
  display: block;
`;
const tableTable = styled.css`
  display: table;
`;
const getTableBreakpoints = (breakpoints)=>{
    return breakpoints.map((breakpoint, index)=>{
        return styled.css`
      @media (min-width: ${breakpoint}px) {
        ${index % 2 === 0 ? tableTable : blockTable}
      }
    `;
    });
};
const StyledTable = styled__default.default(UnstyledTable)`
  ${blockTable}
  ${({ breakpoints  })=>getTableBreakpoints(breakpoints || [])}
  background-color: ${({ look , theme  })=>theme.table[look].backgroundColor};
  border-collapse: collapse;
  border-spacing: 0;
  box-sizing: border-box;
  color: ${({ look , theme  })=>theme.table[look].textColor};
  font-family: ${fonts.fontFamilyBook};
  font-size: 14px;
  line-height: 22px;
  position: relative;
  white-space: normal;
  width: 100%;

  > .bf-table__standard-tbody {
    > .bf-table__standard-tr:hover {
      background-color: ${({ empty , error , hover , loading , look , theme  })=>!empty && !error && !loading && hover ? theme.table[look].trHoverBackgroundColor : 'transparent'};
    }
  }
`;
/**
 * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/table
 * @param props TableProps
 * @returns FunctionComponent<TableProps>
 */ const Table = (props)=>{
    const { breakpoints , look =table.TableLooks.Default , maxHeight , scrollX =true , scrollY , ...otherProps } = props;
    const themeContext = React.useContext(styled.ThemeContext);
    const table$1 = /*#__PURE__*/ React__default.default.createElement(StyledTable, _extends({}, otherProps, {
        breakpoints: breakpoints,
        look: look
    }));
    return /*#__PURE__*/ React__default.default.createElement(styled.ThemeProvider, {
        theme: themeContext || themes.lightTheme
    }, scrollX || scrollY ? /*#__PURE__*/ React__default.default.createElement(tableWrapper.TableWrapper, {
        breakpoints: breakpoints,
        scrollX: scrollX,
        scrollY: scrollY,
        style: {
            maxHeight: scrollY ? maxHeight || '500px' : undefined
        }
    }, table$1) : table$1);
};

exports.Table = Table;
//# sourceMappingURL=table.js.map
